var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkedUnpaid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#E1ECF7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#357ABC",
    fillRule: "evenodd",
    clipPath: "url(#marked-unpaid)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 13.571c.592 0 1.071.48 1.071 1.072v.754a2.856 2.856 0 0 1 2.218 1.865 1.071 1.071 0 1 1-2.02.714.713.713 0 0 0-.674-.476h-1.382a.522.522 0 0 0-.112 1.033l2.105.46a2.858 2.858 0 0 1-.135 5.61v.754a1.071 1.071 0 0 1-2.143 0v-.754a2.86 2.86 0 0 1-2.218-1.865 1.071 1.071 0 1 1 2.02-.714.715.715 0 0 0 .675.476h1.19a.715.715 0 0 0 .153-1.413l-2.105-.46a2.665 2.665 0 0 1 .285-5.255v-.73c0-.591.48-1.07 1.072-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.143 20a7.857 7.857 0 0 1 14.027-4.865l-1.38 1.38a.714.714 0 0 0 .506 1.22h3.99c.394 0 .714-.32.714-.715v-3.99a.714.714 0 0 0-1.22-.505l-1.086 1.087A9.98 9.98 0 0 0 20 10c-5.523 0-10 4.477-10 10s4.477 10 10 10c4.73 0 8.69-3.283 9.732-7.693a1.071 1.071 0 0 0-2.085-.493A7.857 7.857 0 0 1 12.143 20Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "marked-unpaid"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10 10h20v20H10z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkedUnpaid);
export default __webpack_public_path__ + "static/media/marked-unpaid.fa14f41a20d95bc5dc8523708718ee64.svg";
export { ForwardRef as ReactComponent };